import { isolateComponent } from '@zapier/style-encapsulation';
import { BaseButton } from './BaseButton';
export function Button(props) {
    return isolateComponent(BaseButton, Object.assign({}, props));
}
Button.defaultProps = {
    color: 'primary',
    size: 'medium',
};
//# sourceMappingURL=Button.js.map
// @zapier/design-system@5.26.3 (1a8819ee6)
